import { createAuthClient } from 'better-auth/react';
import { organizationClient } from 'better-auth/client/plugins';
import { magicLinkClient } from 'better-auth/client/plugins';
import { genericOAuthClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  baseURL: typeof window !== 'undefined' ? window.location.origin : undefined,
  plugins: [organizationClient(), magicLinkClient(), genericOAuthClient()],
});

export const { useSession, signIn, signOut, signUp, useActiveOrganization, organization } =
  authClient;

export type AuthClient = typeof authClient;
